import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Output, Renderer2 } from '@angular/core';
import { take, timer } from 'rxjs';
import { BasePageComponent } from 'src/app/components/base-page/base-page.component';
import { DepositService } from 'src/app/services/payment/deposit/deposit.service';

declare const PraxisGate: any;
@Component({
  selector: 'app-praxis-hpf',
  templateUrl: './praxis-hpf.component.html',
  styleUrls: ['./praxis-hpf.component.scss']
})
export class PraxisHpfComponent extends BasePageComponent {

  constructor(
    private depositService: DepositService,
    @Inject(DOCUMENT) private document: Document,
    private _renderer2: Renderer2,

  ) { super() }

  sessioTtoken: string;
  praxisGateInstance: any;

  ngOnInit(): void {
    let sdk = this._renderer2.createElement('script');
    let isSandboxHPF = true;
    let src = isSandboxHPF
      ? 'https://cdn-pci.cashier-test.com/PraxisGate.js'
      : 'https://cdn.praxisgate.com/PraxisGate.js';
    sdk.type = `text/javascript`;
    sdk.src = src + '?t=' + (new Date()).getTime();
    document.querySelector('head').appendChild(sdk);
    console.log("praxis hpf")
    this.depositService.getPraxisHpfSession().pipe(take(1)).subscribe((resp) => {
      console.log("praxis", resp.session_token)
      this.sessioTtoken = resp.session_token;
      this.initializePraxis(resp.session_token);
    })


  }

  getCardDetails() {
    return this.praxisGateInstance.tokenizeCard();
  }

  initializePraxis(sessionToken: string) {

    const praxisGateInterval = timer(0, 15).subscribe(() => {
      if (typeof (<any>window).PraxisGate !== 'undefined') {
        this.praxisGateInstance = new PraxisGate({
          sessionToken: sessionToken,
          containers: {
            card_number: '#secure-card-number',
            card_holder: '#secure-card-holder',
            exp: '#secure-exp',
            cvv: '#secure-cvv',
          },
          onValid: function () {
            let tokenizePromise = this.praxisGateInstance.tokenizeCard();
            tokenizePromise.then(function (token) {
              console.log("Praxis token", token)
              // if (token === sessionToken) {
              //   (<any>(<any>document.getElementById('submit'))).disabled = false;
              // } else {
              //   (<any>document.getElementById('submit')).disabled = true;
              // }
            })
          },
          onInvalid: function () {
            // (<any>document.getElementById('submit')).disabled = true;
          },
          onFocus: function (fieldName) { },
          onBlur: function (fieldName) { },
          onClick: function (fieldName) { },
          onValidationSuccess: function (fieldName) { },
          onValidationError: function (fieldName) { },
          onLoad: function () {
            let customerListPromise = this.praxisGateInstance.getCustomerCards(); // list of available templates also can be received by Agent API get_customer_cards request
            customerListPromise.then(function (list) {
              // merchants business logic to process customer cards list
            })
            let availableGatewaysListDataObject = {
              "gateway_type": null, // insert here value if needed
              "gateway": null, // insert here value if needed
              "country": null, // insert here value if needed
              "currency": null, // insert here value if needed
              "locale": null, // insert here value if needed
              "payment_method": null, // insert here value if needed
              "amount": null, // insert here value if needed
              "card_token": null, // insert here value if needed
              "include_payment_information": null, // insert here value if needed
            }
            let availableGatewaysListPromise = this.praxisGateInstance.getAvailableGateways(availableGatewaysListDataObject); // list of available gateways also can be received by Agent API get_available_gateways request
            availableGatewaysListPromise.then(function (list) {
              // merchants business logic to process gateways list
            })
            // ready to run merchants business logic
          },
          css: `
                            input {
                                border: none;
                                background: none;
                                outline: transparent;
                                font-size: 16px;
                                font-family: Courier;
                            },
                            .card-number {
                                width: '100%';
                            }
                        `,
          labels: {
            display: [(<any>window).PG_INPUT_SHOW_LABELS, (<any>window).PG_INPUT_SHOW_PLACEHOLDERS],
            label_card_number: 'Credit Card',
            label_card_holder: 'Card Holder',
            label_exp: 'Expires',
            label_cvv: 'CSC/CVV',
            placeholder_card_number: '0000 0000 0000 0000',
            placeholder_card_holder: 'Card Holder Name',
            placeholder_exp: 'MM/YY',
            placeholder_cvv: 'CVV'
          }
        });
        this.praxisGateInstance.sendCSS({ input: { color: '#555' } });
        praxisGateInterval.unsubscribe();
      }
    })

  }
}